import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { useIntl } from 'react-intl';
import { findNodeByLocale } from '../../../helpers/translations';
import { EmailOptInForm, FormSectionQueryData } from '../../email-opt-in-form/EmailOptInForm';

const query = graphql`
  query {
    data: allContentfulFormSection(
      filter: { name: { eq: "newsletter-footer" } }
    ) {
      ...FormSection
    }
  }
`;

export const FooterNewsletter = () => {
  const intl = useIntl();
  const { data = {} } = useStaticQuery<FormSectionQueryData>(query);

  const {
    title,
    hubspotForm,
    description,
  } = findNodeByLocale(data.nodes || [], intl.locale) || {};

  return (
    <EmailOptInForm
      hubspotFormId={hubspotForm}
      title={title}
      description={description}
      className=""
    />
  );
};
